import { useSort } from "@nosto/search-js/preact/hooks"
import { sortOptions } from "@/config"
import Select from "@/elements/Select/Select"
import styles from "./Toolbar.module.css"
import { useFilterSidebar } from "@/contexts/SidebarContext"

/**
 * Results toolbar.
 * Desktop: a full-width grey bar with the "Sort By" control on the right.
 * Mobile: two buttons — FILTER (opens the filter drawer) and SORT BY.
 */
export default function Toolbar() {
  const { activeSort, setSort } = useSort(sortOptions)
  const { setOpen } = useFilterSidebar()

  const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

  return (
    <>
      <div className={styles.container}>
        <div className={styles.sort}>
          <span className={styles.sortLabel}>Sort By:</span>
          <Select
            value={activeSort}
            onChange={e => setSort((e.target as HTMLSelectElement)?.value)}
            className={styles.sortMenu}
            options={options}
            label="Sort By"
          />
        </div>
      </div>

      <div className={styles.mobileBar}>
        <button type="button" className={styles.mobileButton} onClick={() => setOpen(true)}>
          <svg className={styles.mobileIcon} viewBox="0 0 16 16" aria-hidden="true">
            <path d="M1 4h14M1 8h14M1 12h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          Filter
        </button>
        <div className={`${styles.mobileButton} ${styles.mobileSort}`}>
          <svg className={styles.mobileIcon} viewBox="0 0 16 16" aria-hidden="true">
            <path
              d="M5 3v10M5 13l-2-2M5 13l2-2M11 13V3M11 3L9 5M11 3l2 2"
              stroke="currentColor"
              strokeWidth="1.3"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Sort By
          <select
            className={styles.mobileSelect}
            value={activeSort}
            onChange={e => setSort((e.target as HTMLSelectElement)?.value)}
            aria-label="Sort by"
          >
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </>
  )
}
